import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=b56931cc&scoped=true"
import script from "./BackOffice.vue?vue&type=script&setup=true&lang=js"
export * from "./BackOffice.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BackOffice.vue?vue&type=style&index=0&id=b56931cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56931cc",
  null
  
)

export default component.exports